import { render, staticRenderFns } from "./reserve-pay.vue?vue&type=template&id=95b3433a&scoped=true&"
import script from "./reserve-pay.vue?vue&type=script&lang=js&"
export * from "./reserve-pay.vue?vue&type=script&lang=js&"
import style0 from "./reserve-pay.vue?vue&type=style&index=0&id=95b3433a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3433a",
  null
  
)

export default component.exports